// ======================================================================
// File Name       : message
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { HIDE_MESSAGE, SHOW_MESSAGE } from '../constants/actionTypes/message';
import { MESSAGE_TYPE } from '../constants';

const initialState = {
  messageVisible: false,
  messageType: MESSAGE_TYPE.error,
  messageHeader: '',
  messageContent: [],
};

export default function content(state = initialState, action) {
  switch (action.type) {
    case HIDE_MESSAGE:
      return { ...initialState };
    case SHOW_MESSAGE: {
      const { header, message, targetModal, statusCd, messageType } = action;
      return {
        ...state,
        ...{
          messageVisible: true,
          messageHeader: header,
          messageContent: message,
          targetModal,
          statusCd,
          messageType,
        },
      };
    }
    default:
      return state;
  }
}
